import { ReactNode } from 'react';
import * as S from './ItemImage.styles';

export const ItemImage = ({ children }: { children: ReactNode }) => {
    return <S.Item>{children}</S.Item>;
};
